var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-select',{attrs:{"readonly":_vm.readonly,"disable":_vm.disable,"label":_vm.label_,"clearable":_vm.field.null,"rules":_vm.rules,"lazy-rules":"","options":[
    { label: this.$t('no'), value: false },
    { label: this.$t('yes'), value: true }
  ],"value":_vm.v,"hint":_vm.hint},on:{"input":function($event){return _vm.$emit('input', $event ? $event.value : $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }